import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue'),
      needAuth: false
    },
    {
      path: '/cafes',
      name: 'cafes',
      component: () => import(/* webpackChunkName: "cafes" */ '@/views/Cafes.vue'),
      needAuth: true
    },
    {
      path: '/loadmenu',
      name: 'loadmenu',
      component: () => import(/* webpackChunkName: "loadmenu" */ '@/views/LoadMenu.vue'),
      needAuth: true
    },
    {
      path: '/viewmenu',
      name: 'viewmenu',
      component: () => import(/* webpackChunkName: "viewmenu" */ '@/views/ViewMenu.vue'),
      needAuth: true
    },
    {
      path: '/cashiers',
      name: 'cashiers',
      component: () => import(/* webpackChunkName: "cashiers" */ '@/views/Cashiers.vue'),
      needAuth: true
    },
    {
      path: '/cafereports',
      name: 'cafereports',
      component: () => import(/* webpackChunkName: "cafereports" */ '@/views/OrgCafeReports.vue'),
      needAuth: true
    },
    {
      path: '/xmlreport',
      name: 'xmlreport',
      component: () => import(/* webpackChunkName: "xmlreport" */ '@/views/OrgXmlReport.vue'),
      needAuth: true
    },
    {
      path: '/requests',
      name: 'requests',
      component: () => import(/* webpackChunkName: "requests" */ '@/views/RequestsByDay.vue'),
      needAuth: true
    },
    {
      path: '/goods',
      name: 'goods',
      component: () => import(/* webpackChunkName: "goods" */ '@/views/Goods.vue'),
      needAuth: true
    },
    {
      path: '/cartdumps',
      name: 'cartdumps',
      component: () => import(/* webpackChunkName: "cartdumps" */ '@/views/CartDumps.vue'),
      needAuth: true
    },
    {
      path: '/saletypes',
      name: 'saletypes',
      component: () => import(/* webpackChunkName: "saletypes" */ '@/views/SaleTypes.vue'),
      needAuth: true
    }
  ]
})
